import {ChangeDetectorRef, Component, OnInit, OnDestroy, ViewChild, ViewEncapsulation, ViewRef} from '@angular/core';
import {MatRadioChange} from '@angular/material/radio';
import {ReportParameterModel} from '../models/ReportParameterModel.model';
import {DomSanitizer} from '@angular/platform-browser';
import {ReportViewerParameterModel} from '../models/ReportViewerParameterModel.model';
import {ReportsService} from '../reports.service';
import {ReportCategoryModel} from '../models/ReportCategoryModel.model';
import {DataTypeEnum} from '../../../models/enum/data-type.enum';
import {ReportListModel} from '../models/ReportListModel.model';
import {TdoDropdownModel} from '../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import {StaticDataService} from '../../../services/static-data.service';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {MatSelectChange} from '@angular/material/select';
import {TdoTableRowModel} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-row.model';
import {MatListOption} from '@angular/material/list';
import {Globals} from '../../../globals';
import {ReportStartUpObjectModel} from '../models/ReportStartUpObject.model';
import {ReportAgingFilterModel} from '../models/ReportAgingFilterModel.model';
import {ReportAgingFilterComponent} from '../report-viewer-filters/report-aging-filter/report-aging-filter.component';
import {
  ReportFinancialSummaryFilterComponent
} from '../report-viewer-filters/report-financial-summary-filter/report-financial-summary-filter.component';
import {ReportFinancialFilterModel} from '../models/ReportFinancialFilterModel.model';
import {DatePipe} from '@angular/common';
import {ReportFinancialSnapshotFilterModel} from '../models/ReportFinancialSnapshotFilterModel.model';
import {
  ReportFinancialSnapshotFiltersComponent
} from '../report-viewer-filters/report-financial-snapshot-filters/report-financial-snapshot-filters.component';
import {environment} from '../../../../environments/environment';
import {ReportFinancialSnapshotComponent} from '../report-financial-snapshot/report-financial-snapshot.component';
import { ajaxSetup } from '../devexpress-reporting-utils';
import {Router} from '@angular/router';
import {
  ReportFrontDeskFiltersComponent
} from '../report-viewer-filters/report-front-desk-filters/report-front-desk-filters.component';
import {ReportFrontDeskFilterModel} from '../models/ReportFrontDeskFilterModel.model';
import {EnterpriseService} from '../../../services/enterprise.service';
import {ReportCategory, ReportClass, ReportIDEnum} from '../../../models/enum/report-ID-enum';
import {ConversionUtilities} from '../../../utilities/conversion.utilities';
import {DxReportViewerComponent} from 'devexpress-reporting-angular';
import {Subject} from 'rxjs';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {MessagingService} from '../../../services/messaging.service';
import {UiService} from '../../../services/ui.service';
import {
  ReportLetterSubstituteParameterModel,
  ReportsLetterSubstituteModel
} from '../models/ReportsLetterSubstituteModel';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {concatMap, takeUntil} from "rxjs/operators";
import { ReportReportsToBeCompletedComponent } from '../report-reports-to-be-completed/report-reports-to-be-completed/report-reports-to-be-completed.component';
import { ReportReportsToBeCompletedParamsModel } from '../models/ReportPatientStatementParamsModel.model';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface IParams {
  isProvider: boolean;
  isPractice: boolean;
  PracticeId: number;
  ProviderId: string;
  PracticeLocations: string[];
  ProvidersId: string[];
  initialDate: string;
  endDate: string;
  isAsc: boolean;
  showInactive: boolean;
  reportName: string;
  dateRange: string;
  CurrentLocation: string;
}

/** Configuration for report filter visibility and behavior */
interface ReportFilterConfig {
  showAgingFilters?: boolean;
  showFinancialSnapshotFilters?: boolean;
  showFrontDeskFilters?: boolean;
  showReportsToBeCompletedFilters?: boolean;
  isSnapShotReport?: boolean;
  isDailySnapShot?: boolean;
  isGeneric?: boolean;
  isEnvelop?: boolean;
  isTreatmentPlan?: boolean;
  hasDevReportParam?: boolean;
  isSnapshotDevExpress?: boolean;
}

@Component({
  standalone: false,
  selector: 'app-report-viewer',
  templateUrl: './report-viewer-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './report-viewer-dialog.component.css',
    '../../../../../node_modules/jquery-ui/themes/base/all.css',
    '../../../../../node_modules/devextreme/dist/css/dx.common.css',
    '../../../../../node_modules/devextreme/dist/css/dx.light.css',
    '../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css',
    '../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css',
    '../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css'
  ]
})


export class ReportViewerDialogComponent implements OnInit, OnDestroy {
  private readonly storedUser = JSON.parse(localStorage.getItem('storedUser'));
  private readonly destroy$ = new Subject<void>();

  /** Configuration map for report filters - replaces long if-else chain */
  private readonly filterConfigMap: ReadonlyMap<string, ReportFilterConfig> = new Map([
    [ReportIDEnum.reportID_PatientStatement, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_List_of_Appointments, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_AgingAnalysis, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_TransactionReport, { showAgingFilters: true, isGeneric: false }],
    [ReportIDEnum.reportID_VoidedTransactionReport, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_Financial_AuditReport, { showAgingFilters: true, isGeneric: false }],
    [ReportIDEnum.reportID_LedgerTransactionReport, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_FinancialSummary, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_FinancialSnapshot, { showFinancialSnapshotFilters: true }],
    [ReportIDEnum.reportID_AllDoctors, { hasDevReportParam: true }],
    [ReportIDEnum.reportID_FinancialSnapshotReport, { isSnapShotReport: true, showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_DailySnapshot, { isSnapShotReport: true, showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_FrontDesk_Envelops, { showFrontDeskFilters: true, isEnvelop: true }],
    [ReportIDEnum.reportID_FrontDesk_TreatmentPlan, { showFrontDeskFilters: true, isTreatmentPlan: true }],
    [ReportIDEnum.reportID_FrontDesk_WalkOutSlip, {}], // No special filters
    [ReportIDEnum.reportID_Credit_Balance, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_CreditCardReceiptReport, { showAgingFilters: true, isGeneric: false }],
    [ReportIDEnum.reportID_RecallReport, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_ProceduresWithNoClaims, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_ClaimsNoSent, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_OutstandingClaims, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_BankDeposits, { showAgingFilters: true, isGeneric: false }],
    [ReportIDEnum.reportID_FeeCalculationReport, { showAgingFilters: true, isGeneric: false }],
    [ReportIDEnum.reportID_ReferringAnalysis, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_PatientsNeedAppointment, { showAgingFilters: true, isGeneric: false }],
    [ReportIDEnum.reportID_Recall_Appointment, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_Call_List, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_Collection_Report, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_Unapplied_Credits, { showAgingFilters: true, isGeneric: true }],
    [ReportIDEnum.reportID_Deleted_Anesthesia, { showAgingFilters: true, isGeneric: false }],
    [ReportIDEnum.reportID_Patient_Case_Referrals, { showAgingFilters: true, isGeneric: false }],
    [ReportIDEnum.reportID_Reports_to_be_completed, { showAgingFilters: true, isGeneric: true, showReportsToBeCompletedFilters: true, isSnapshotDevExpress: false }],
  ]);

  /** Map of report IDs to their handler methods - replaces long if-else chain in runReport() */
  private readonly reportHandlerMap: ReadonlyMap<string, () => void> = new Map([
    [ReportIDEnum.reportID_PatientStatement, () => this.patientStatementParams()],
    [ReportIDEnum.reportID_List_of_Appointments, () => this.listOfAppointmentsParams()],
    [ReportIDEnum.reportID_AllDoctors, () => this.allDoctorsParams()],
    [ReportIDEnum.reportID_AgingAnalysis, () => this.agingAnalysisParams()],
    [ReportIDEnum.reportID_FinancialSummary, () => this.financialSummaryParams()],
    [ReportIDEnum.reportID_FinancialSnapshot, () => this.financialSnapshotBreakDownParams()],
    [ReportIDEnum.reportID_FinancialSnapshotReport, () => this.financialSnapshotParams()],
    [ReportIDEnum.reportID_DailySnapshot, () => this.financialDailySnapshotParams()],
    [ReportIDEnum.reportID_FrontDesk_Envelops, () => this.frontDeskEnvelopParams()],
    [ReportIDEnum.reportID_FrontDesk_TreatmentPlan, () => this.frontDeskTreatmentPlanParams()],
    [ReportIDEnum.reportID_FrontDesk_WalkOutSlip, () => this.frontDeskWalkOutSlip()],
    [ReportIDEnum.reportID_BankDeposits, () => this.bankDeposits()],
    [ReportIDEnum.reportID_FeeCalculationReport, () => this.feeCalculationReport()],
    [ReportIDEnum.reportID_TransactionReport, () => this.transactionReport()],
    [ReportIDEnum.reportID_VoidedTransactionReport, () => this.voidedTransactionReport()],
    [ReportIDEnum.reportID_LedgerTransactionReport, () => this.ledgerTransactionReport()],
    [ReportIDEnum.reportID_Financial_AuditReport, () => this.financialAuditReport()],
    [ReportIDEnum.reportID_Credit_Balance, () => this.creditBalanceReport()],
    [ReportIDEnum.reportID_CreditCardReceiptReport, () => this.creditCardReceiptReport()],
    [ReportIDEnum.reportID_RecallReport, () => this.recallReport()],
    [ReportIDEnum.reportID_ProceduresWithNoClaims, () => this.proceduresWithNoClaimsReport()],
    [ReportIDEnum.reportID_ClaimsNoSent, () => this.claimsNoSentReport()],
    [ReportIDEnum.reportID_OutstandingClaims, () => this.OutstandingClaimsReport()],
    [ReportIDEnum.reportID_ReferringAnalysis, () => this.referringAnalysisReport()],
    [ReportIDEnum.reportID_PatientsNeedAppointment, () => this.patientsNeedAppointmentReport()],
    [ReportIDEnum.reportID_Recall_Appointment, () => this.recallAppointmentReport()],
    [ReportIDEnum.reportID_Call_List, () => this.callListReport()],
    [ReportIDEnum.reportID_Collection_Report, () => this.collectionReport()],
    [ReportIDEnum.reportID_Unapplied_Credits, () => this.unappliedCreditsReport()],
    [ReportIDEnum.reportID_Deleted_Anesthesia, () => this.deletedAnesthesiaReport()],
    [ReportIDEnum.reportID_Patient_Case_Referrals, () => this.patientCaseReferralsReport()],
    [ReportIDEnum.reportID_Reports_to_be_completed, () => this.reportsToBeCompletedReport()],
  ]);

  constructor(
    public domSanitizer: DomSanitizer,
    private readonly reportService: ReportsService,
    private readonly staticDataService: StaticDataService,
    private readonly globals: Globals,
    private readonly datePipe: DatePipe,
    private readonly router: Router,
    private readonly enterpriseService: EnterpriseService,
    private readonly messagingService: MessagingService,
    private readonly uiService: UiService,
    private readonly snackBar: MatSnackBar,
    private readonly cdr: ChangeDetectorRef
  ) {
    window.resizeTo(screen.width, screen.height);
  }

  reportCategoryEnumItems: EnumValidValueItemModel[];
  reportByCategoryEnumItems: EnumValidValueItemModel[];
  // enterpriseModel: TdoEnterpriseConfigurationModel;
  enterpriseId: string = '';

  reportStartUpObject: ReportStartUpObjectModel;
  patientId: string;
  enumReportCategoryId: string;
  reportId: string;
  // Use this line if you use an ASP.NET MVC backend
  // invokeAction = '/WebDocumentViewer/Invoke';
  // Use this line if you use an ASP.NET Core backend (DevExpress 25.x)
  invokeAction = 'RSWebDocumentViewerApi/Invoke';

  title = 'DXReportViewer';
  reportUrl: string;
  emptyReportUrl: string;
  reportToPDFUrl: string;
  hostUrlDXXRDV: string;
  hostUrlReporting: string;
  // invokeAction = '/DXXRDV';
  reportName = '';
  currentPatientName: string = '';
  hasCurrentPatient: boolean = true;

  // Front Desk Report Child
  frontDeskReportChild: string;
  isEnvelop: boolean = false;
  isTreatmentPlan: boolean = false;

  isLoading: boolean;
  isReportViewer: boolean;
  hasDevReportParam: boolean = true;
  blShowReportsByCategory: boolean;
  blReportByCategorySelected: boolean;
  showAgingFilters: boolean;
  showFinancialSummaryFilters: boolean;
  showFinancialSnapshotFilters: boolean = false;
  showReportsToBeCompletedFilters: boolean;
  showFrontDeskFilters: boolean;
  selectedEnumReportCategoryID: string;
  selectedEnumReportCategory: any;
  activeReport: ReportListModel;
  reportStartUpInstructions: ReportStartUpObjectModel;
  isSnapShotReport: boolean = false;
  isDailySnapShot: boolean = false;
  isSnapshotDevExpress: boolean = false;


  showParametersForReport: string = '';
  isGeneric: boolean = false;

  reportViewerParameters: ReportViewerParameterModel[] = [];
  reportParameters: ReportParameterModel[] = [];
  reportParametersNumber: ReportParameterModel[] = [];
  reportParametersString: ReportParameterModel[] = [];
  reportParametersBoolean: ReportParameterModel[] = [];
  reportParametersDateTime: ReportParameterModel[] = [];
  reports: ReportListModel[] = [];
  reportCategories: ReportCategoryModel[] = [];
  
  /** Cached filtered reports by category to avoid recalculating on every change detection */
  private _cachedReportsByCategory: ReportListModel[] = [];

  tempUserFormPasswords: any = [];
  reportAgingFilters: ReportAgingFilterModel;
  reportFinancialFilters: ReportFinancialFilterModel;
  reportFinancialSnapshotFilters: ReportFinancialSnapshotFilterModel;
  reportFrontDeskFilters: ReportFrontDeskFilterModel;
  get authToken(): string | null {
    return localStorage.getItem('TDOauthToken');
  }
  isSpecificReport: boolean = false;
  isEmptyReport: boolean = false;
  showLetterSub: boolean = false;
  ReportsLetterSubstitute: ReportsLetterSubstituteModel;
  isLetterSubstitute: boolean = false;

  // Single ViewChild for the aging filter component (only one instance exists in template)
  @ViewChild(ReportAgingFilterComponent) reportAgingFilter: ReportAgingFilterComponent;

  @ViewChild(ReportFinancialSummaryFilterComponent) reportFinancialFilter: ReportFinancialSummaryFilterComponent;
  @ViewChild(ReportFinancialSnapshotFiltersComponent) reportFinancialSnapshotBreakDownFilter: ReportFinancialSnapshotFiltersComponent;
  @ViewChild(ReportFinancialSnapshotComponent) ReportFinancialSnapshot: ReportFinancialSnapshotComponent;
  @ViewChild(ReportFrontDeskFiltersComponent) ReportFrontDesk: ReportFrontDeskFiltersComponent;
  @ViewChild(ReportReportsToBeCompletedComponent) reportReportsToBeCompleted: ReportReportsToBeCompletedComponent;

  @ViewChild(DxReportViewerComponent, {static: false}) viewer: DxReportViewerComponent;


  ngOnInit(): void {
    // get reports
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === '') {
      this.createMessage('No Active Patient selected', 'TDOS');
      this.hasCurrentPatient = false;

      // if not current patient Listening for patient_changed
      this.messagingService.componentMessageCall
        .pipe(takeUntil(this.destroy$))
        .subscribe(response => {
          if (response.event === MessagingConstants.PATIENT_CHANGED && response.data.PatientID !== null) {
            this.hasCurrentPatient = true;
          }
        });


    } else {
      this.hasCurrentPatient = true;
    }
    this.reportStartUpObject = JSON.parse(localStorage.getItem('object'));
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          if ((this.cdr as ViewRef).destroyed) { return; }
          this.setupPage();
          this.cdr.detectChanges();
        }
      });
    } else {
      this.setupPage();
    }

    this.reportService.getReports()
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        // reports
        this.reports = response;
        // load page
        if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
      }, err => {
        this.createMessage('Error getting reports', 'Error');
        this.isLoading = false;
        if (!(this.cdr as ViewRef).destroyed) { this.cdr.detectChanges(); }
      });
    // get report category types	
	this.hostUrlDXXRDV = environment.tdoxReportingUrlDXXRDV;
	this.hostUrlReporting = environment.tdoxReportingUrl;
    // this.hostUrl = environment.tdoxReportingUrl + this.storedUser.authdata.userid;
    // this.hostUrl = 'https://tdocxreporting20220902165706.azurewebsites.net/';
    ajaxSetup.ajaxSettings = {};
    this.enterpriseId = localStorage.getItem('TDOEnterpriseId');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addItem(newItem: ReportAgingFilterModel) {
    this.reportAgingFilters = newItem;

  }

  addItemFinancial(newItem: ReportFinancialFilterModel) {
    this.reportFinancialFilters = newItem;
  }

  addItemFinancialSnapshot(newItem: ReportFinancialSnapshotFilterModel) {
    this.reportFinancialSnapshotFilters = newItem;
  }

  addItemFrontDesk(newItem: ReportFrontDeskFilterModel) {
    this.reportFrontDeskFilters = newItem;
  }

  setupPage() {
    // create report entry point
    // validate if user needs to perform an action
    if (this.reportStartUpObject.reportStartUpInstructions.ShowViewer) {
      this.isReportViewer = true;
    }
    // patient..... need to validate if the general report viewer will send current PatientID,
    // report categories
    this.reports.forEach(a => {
      if (!this.reportCategories.some(f => f.enumReportCategoryID === a.enumReportCategoryID)) {
        const reportCategory: ReportCategoryModel = new ReportCategoryModel();
        reportCategory.enumReportCategoryID = a.enumReportCategoryID;
        reportCategory.Name = a.CategoryName;
        this.reportCategories.push(reportCategory);
      }
    });
    //

    // Execute Run Report, without additional parameters
    if (this.reportStartUpObject.reportStartUpInstructions.ReportID) {
      this.isSpecificReport = true;
      this.reports = this.reports.filter(a => a.ReportID.toUpperCase() === this.reportStartUpObject.reportStartUpInstructions.ReportID.toUpperCase());
      this.activeReport = this.reports[0];

      // run report
      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_ARClaim) {
        this.arcClaimParams();
        this.reportName = this.reports[0].ReportName; // for now
        return;
      }

      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_PatientStatement) {
        this.runReport();
        return;
      }

      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_FrontDesk_WalkOutSlip) {
        this.runReport();
        return;
      }

      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_Comparison_Report) {
        this.reportName = 'Comparison Report';
        this.PerioChartComparisonReportParams();
        return;
      }

      if (this.reportStartUpObject.reportStartUpInstructions.ReportID === ReportIDEnum.reportID_PerioChart_Report) {
        this.reportName = 'Perio Chart Report';
        this.PerioChartReportParams();
        return;
      }


    }
    if (this.reportStartUpObject.reportStartUpInstructions.enumReportCategoryID) {
      this.selectedEnumReportCategoryID = this.reportStartUpObject.reportStartUpInstructions.enumReportCategoryID;
      return;
    }
    // no parameters for Report, user needs to select category and report
    if (!this.reportStartUpObject.reportStartUpInstructions.enumReportCategoryID && !this.reportStartUpObject.reportStartUpInstructions.ReportID) {
      this.reportCategoryEnumItems = this.staticDataService.getValidValueItemsByValidValueName('enumReportCategory');
      const referralIndex = this.reportCategoryEnumItems.findIndex(p => p.ValidValueItemId === ReportCategory.Referral);
      if (referralIndex !== -1) {
        this.reportCategoryEnumItems.splice(referralIndex, 1);
      }
      this.reportByCategoryEnumItems = this.staticDataService.getValidValueItemsByValidValueId(ReportCategory.AccountRecevables);
      this.blShowReportsByCategory = true;
      return;
    }
  }

  resetParamVars() {
    this.reportParameters = [];
    this.reportParametersNumber = [];
    this.reportParametersString = [];
    this.reportParametersBoolean = [];
    this.reportParametersDateTime = [];
  }

  reportSelected(event: MatRadioChange): void {
    // set active
    this.activeReport = event.value;
    // show parameters
    this.showParameters();
  }

  onGroupsChange(options: MatListOption[]) {
    // set active
    this.activeReport = options.map(o => o.value)[0];
    // show parameters
    this.showParameters();
    this.showFilters();

  }

  onReportSelected(report: ReportListModel, event: any) {
    if (event.isUserInput) {
      this.activeReport = report;
      this.reportName = report.ReportName;
      this.isEmptyReport = true;
      // show parameters
      this.showParameters();
      this.showFilters();
      this.isSnapshotDevExpress = false;

    }
  }

  private createEnumDropdownModels(enumName: string): TdoDropdownModel[] {
    const enums = this.staticDataService.getValidValueItemsByValidValueName(enumName);
    const ddModels: TdoDropdownModel[] = [];
    if (enums) {
      for (const vvi of enums) {
        ddModels.push(new TdoDropdownModel(vvi.ItemDisplayValue, vvi));
      }
    }
    return ddModels;
  }

  showFilters(): void {
    // Reset all filter flags to defaults
    this.resetFilterFlags();

    const reportId = this.activeReport.ReportID.toUpperCase();
    const config = this.filterConfigMap.get(reportId);

    if (config) {
      // Apply configuration from map
      this.showAgingFilters = config.showAgingFilters ?? false;
      this.showFinancialSnapshotFilters = config.showFinancialSnapshotFilters ?? false;
      this.showFrontDeskFilters = config.showFrontDeskFilters ?? false;
      this.showReportsToBeCompletedFilters = config.showReportsToBeCompletedFilters ?? false;
      this.isSnapShotReport = config.isSnapShotReport ?? false;
      this.isDailySnapShot = config.isDailySnapShot ?? false;
      this.isGeneric = config.isGeneric ?? false;
      this.isEnvelop = config.isEnvelop ?? false;
      this.isTreatmentPlan = config.isTreatmentPlan ?? false;
      
      if (config.hasDevReportParam !== undefined) {
        this.hasDevReportParam = config.hasDevReportParam;
      }
      if (config.isSnapshotDevExpress !== undefined) {
        this.isSnapshotDevExpress = config.isSnapshotDevExpress;
      }

      // Set showParametersForReport if aging filters are shown
      if (config.showAgingFilters) {
        this.showParametersForReport = reportId;
      }
    }
  }

  /** Reset all filter-related flags to their default values */
  private resetFilterFlags(): void {
    this.showAgingFilters = false;
    this.showFinancialSummaryFilters = false;
    this.showFinancialSnapshotFilters = false;
    this.showReportsToBeCompletedFilters = false;
    this.isSnapShotReport = false;
    this.isDailySnapShot = false;
    this.showFrontDeskFilters = false;
    this.showParametersForReport = '';
    this.isGeneric = false;
    this.isEnvelop = false;
    this.isTreatmentPlan = false;
  }

  showParameters() {
    // reset report param vars
    this.resetParamVars();
    // present any parameter inputs
    if (this.activeReport.cfgReportParameters) {
      this.activeReport.cfgReportParameters.forEach(a => {
        // load up params based on type
        if (a.enumDataTypeID) {
          if (a.enumDataTypeID === DataTypeEnum.String) {
            this.reportParametersString.push(a);
          } else if (a.enumDataTypeID === DataTypeEnum.Integer) {
            this.reportParametersNumber.push(a);
          } else if (a.enumDataTypeID === DataTypeEnum.Boolean) {
            this.reportParametersBoolean.push(a);
          } else if (a.enumDataTypeID === DataTypeEnum.DateTime) {
            this.reportParametersDateTime.push(a);
          }
        }
      });
    }
  }

  runReport(): void {
    this.isEmptyReport = true;
    
    const reportId = this.activeReport.ReportID.toUpperCase();
    const handler = this.reportHandlerMap.get(reportId);
    
    if (handler) {
      handler();
    }
  }


  runLetter(event: MatCheckboxChange) {
    this.isLetterSubstitute = event.checked;
  }

  arcClaimParams() {
    this.AddParameterToReport('ARClaimID', this.reportStartUpObject.reportGlobalParameters.ARClaimID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams !== undefined) {
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierA !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierA !== '') {
        this.AddParameterToReport('diagCodeListQualifierA', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierA, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierB !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierB !== '') {
        this.AddParameterToReport('diagCodeListQualifierB', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodeListQualifierB, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimA !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimA !== '') {
        this.AddParameterToReport('diagCodePrimA', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimA, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimB !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimB !== '') {
        this.AddParameterToReport('diagCodePrimB', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimB, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimC !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimC !== '') {
        this.AddParameterToReport('diagCodePrimC', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimC, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimD !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimD !== '') {
        this.AddParameterToReport('diagCodePrimD', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.diagCodePrimD, DataTypeEnum.String);
      }
      if (this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.remarks !== undefined &&
        this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.remarks !== '') {
        this.AddParameterToReport('remarks', this.reportStartUpObject.reportGlobalParameters.ReportADAExtraParams.remarks, DataTypeEnum.String);
      }
    }
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  allDoctorsParams() {
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.showParameters();
    this.getReportUrl();
  }


  PerioChartComparisonReportParams() {
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('currentPerioChartID', this.reportStartUpObject.reportGlobalParameters.currentPerioChartID, DataTypeEnum.String);
    this.AddParameterToReport('oldPerioChartID', this.reportStartUpObject.reportGlobalParameters.oldPerioChartID, DataTypeEnum.String);
    this.AddParameterToReport('LOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  PerioChartReportParams() {
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('currentPerioChartID', this.reportStartUpObject.reportGlobalParameters.currentPerioChartID, DataTypeEnum.String);
    this.AddParameterToReport('LOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  patientStatementParams() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.createMessage('Please select Patient', 'TDOS');
      return;
    }
    if (this.reportAgingFilter.reportPatientStatementFilterModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }

    if (this.isLetterSubstitute) {
      // create WebId Record to send to  Letters Module
      const isProvider = this.reportAgingFilter.reportPatientStatementFilterModel.isProvider ? '1' : '0';
      const isPractice = this.reportAgingFilter.reportPatientStatementFilterModel.isPractice ? '1' : '0';
      const ProvidersId = this.reportAgingFilter.reportPatientStatementFilterModel.ProvidersId ? this.reportAgingFilter.reportPatientStatementFilterModel.ProvidersId.map(e => e.replace(/\s/g, '')).join(',') : '';
      const PracticeLocations = this.reportAgingFilter.reportPatientStatementFilterModel.PracticeLocations ? this.reportAgingFilter.reportPatientStatementFilterModel.PracticeLocations.map(e => e.replace(/\s/g, '')).join(',') : '';
      const initialDate = this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportPatientStatementFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
      const endDate = this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportPatientStatementFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
      let object = new ReportLetterSubstituteParameterModel();
      object.LetterSubstituteID = this.ReportsLetterSubstitute.LetterSubstitueID;
      object.sqlStatement = 'exec tdo.spPatientStatement_LedgerDetails @PatientID = \'' + this.globals.currentPatientId.toUpperCase() + '\'' +
        ', @isProvider = \'' + isProvider + '\'' +
        ', @isPractice = \'' + isPractice + '\'' +
        ', @ProviderDoctorList = \'' + ProvidersId + '\'' +
        ', @PracticeLocationsIdList = \'' + PracticeLocations + '\'' +
        ', @initialDate = \'' + initialDate + '\'' +
        ', @endDate = \'' + endDate + '\'';
      object.isParent = true;
      object.Order = 1;

      this.reportService.saveReportLetterSubstitutionParameter(object).pipe(
        concatMap((result) => {
          if (result) {
            object = result;
            const childObject = new ReportLetterSubstituteParameterModel();
            childObject.WebID = result.WebID;
            childObject.LetterSubstituteID = this.ReportsLetterSubstitute.LetterSubstitueID;
            childObject.sqlStatement = 'EXEC tdo.spPatientStatement_PaymentDist @LedgerID';
            childObject.isParent = false;
            childObject.ParentID = result.ID;
            childObject.Order = 2;
            return this.reportService.saveReportLetterSubstitutionParameter(childObject);

        }}))
          .subscribe(data => {
            this.uiService.openLettersWindow({paramWebId: object.WebID});
          }
      );
    } else { // execute Report
      this.activeReport.cfgReportParameters = [];
      if (this.reportAgingFilter.reportPatientStatementFilterModel.isProvider) {
        this.reportAgingFilter.reportPatientStatementFilterModel.ProvidersId.forEach(provider => {
          this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
          i++;
        });
        this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      }
      if (this.reportAgingFilter.reportPatientStatementFilterModel.isPractice) {
        this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportPatientStatementFilterModel.PracticeId, DataTypeEnum.String);
        this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
        this.reportAgingFilter.reportPatientStatementFilterModel.PracticeLocations.forEach(location => {
          this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
          i++;
        });
      }
      this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportPatientStatementFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportPatientStatementFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
      this.AddParameterToReport('StatementNotes', this.reportAgingFilter.reportPatientStatementFilterModel.statementNote, DataTypeEnum.String);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
      this.hasDevReportParam = false;
      this.showParameters();
      this.getReportUrl();
    }
  }

  listOfAppointmentsParams() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.createMessage('Please select Patient', 'TDOS');
      return;
    }
    if (this.reportAgingFilter.reportListOfAppointmentsModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    if (this.isLetterSubstitute) {
      // create WebId Record to send to  Letters Module
      const isProvider = this.reportAgingFilter.reportListOfAppointmentsModel.isProvider ? '1' : '0';
      const isPractice = this.reportAgingFilter.reportListOfAppointmentsModel.isPractice ? '1' : '0';
      const ProvidersId = this.reportAgingFilter.reportListOfAppointmentsModel.ProvidersId ? this.reportAgingFilter.reportListOfAppointmentsModel.ProvidersId.map(e => e.replace(/\s/g, '')).join(',') : '';
      const PracticeLocations = this.reportAgingFilter.reportListOfAppointmentsModel.PracticeLocations ? this.reportAgingFilter.reportListOfAppointmentsModel.PracticeLocations.map(e => e.replace(/\s/g, '')).join(',') : '';
      const initialDate = this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportListOfAppointmentsModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
      const endDate = this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportListOfAppointmentsModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC');
      let object = new ReportLetterSubstituteParameterModel();
      object.LetterSubstituteID = this.ReportsLetterSubstitute.LetterSubstitueID;
      object.sqlStatement = 'exec TDO.spListOfAppointments_Report @PatientID = \'' + this.globals.currentPatientId.toUpperCase() + '\'' +
        ', @isProvider = \'' + isProvider + '\'' +
        ', @isPractice = \'' + isPractice + '\'' +
        ', @ProvidersIdList = \'' + ProvidersId + '\'' +
        ', @LocationsIdList = \'' + PracticeLocations + '\'' +
        ', @initialDate = \'' + initialDate + '\'' +
        ', @endDate = \'' + endDate + '\'';
      object.isParent = false;
      object.Order = 0;

      this.reportService.saveReportLetterSubstitutionParameter(object).subscribe(result => {
        if (result) {
          object = result;
          this.uiService.openLettersWindow({ paramWebId : object.WebID});
        }
      });
    } else {
      this.activeReport.cfgReportParameters = [];
      if (this.reportAgingFilter.reportListOfAppointmentsModel.isProvider) {
        this.reportAgingFilter.reportListOfAppointmentsModel.ProvidersId.forEach(provider => {
          this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
          i++;
        });
        this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      }
      if (this.reportAgingFilter.reportListOfAppointmentsModel.isPractice) {
        this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportListOfAppointmentsModel.PracticeId, DataTypeEnum.String);
        this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
        this.reportAgingFilter.reportListOfAppointmentsModel.PracticeLocations.forEach(location => {
          this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
          i++;
        });
      }
      this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportListOfAppointmentsModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportListOfAppointmentsModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
      this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
      this.hasDevReportParam = false;
      this.showParameters();
      this.getReportUrl();
    }
  }


  transactionReport() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportTransactionFilterModel === undefined) {

      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportTransactionFilterModel.isProvider) {
      this.reportAgingFilter.reportTransactionFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportTransactionFilterModel.isPractice) {
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportTransactionFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportTransactionFilterModel.PracticeId, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportTransactionFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportTransactionFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('transactionType', this.reportAgingFilter.reportTransactionFilterModel.transactionType, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }


  voidedTransactionReport() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportVoidedTransactionFilterModel === undefined) {

      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportVoidedTransactionFilterModel.isProvider) {
      this.reportAgingFilter.reportVoidedTransactionFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }

    if (this.reportAgingFilter.reportVoidedTransactionFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportVoidedTransactionFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportVoidedTransactionFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportVoidedTransactionFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportVoidedTransactionFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('isOrderByDateCharged', this.reportAgingFilter.reportVoidedTransactionFilterModel.isOrderByDateCharged, DataTypeEnum.Boolean);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  creditBalanceReport() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportCreditBalanceFilterModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportCreditBalanceFilterModel.isProvider) {
      this.reportAgingFilter.reportCreditBalanceFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportCreditBalanceFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportCreditBalanceFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportCreditBalanceFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('isAllProviders', this.reportAgingFilter.reportCreditBalanceFilterModel.isAllProviders, DataTypeEnum.Boolean);
    this.AddParameterToReport('isAllLocations', this.reportAgingFilter.reportCreditBalanceFilterModel.isAllLocations, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    if (this.isLetterSubstitute) {
      // create WebId Record to send in Letter
      const isProvider = this.reportAgingFilter.reportCreditBalanceFilterModel.isProvider ? '1' : '0';
      const isPractice = this.reportAgingFilter.reportCreditBalanceFilterModel.isPractice ? '1' : '0';
      const ProvidersId = this.reportAgingFilter.reportCreditBalanceFilterModel.ProvidersId ? this.reportAgingFilter.reportCreditBalanceFilterModel.ProvidersId.map(e => e.replace(/\s/g, '')).join(',') : '';
      const PracticeLocations = this.reportAgingFilter.reportCreditBalanceFilterModel.PracticeLocations ? this.reportAgingFilter.reportCreditBalanceFilterModel.PracticeLocations.map(e => e.replace(/\s/g, '')).join(',') : '';
      let object = new ReportLetterSubstituteParameterModel();
      object.LetterSubstituteID = this.ReportsLetterSubstitute.LetterSubstitueID;
      object.sqlStatement = 'exec tdo.spCreditBalance_Details  @isProvider = \'' + isProvider + '\'' +
        ', @isPractice = \'' + isPractice + '\'' +
        ', @ProviderDoctorList = \'' + ProvidersId + '\'' +
        ', @PracticeLocationsIdList = \'' + PracticeLocations + '\'';
      object.isParent = false;
      object.Order = 0;

      this.reportService.saveReportLetterSubstitutionParameter(object).subscribe(result => {
        if (result) {
          object = result;
          this.uiService.openLettersWindow({ paramWebId : object.WebID});

        }
      });
    } else {
      this.getReportUrl();
    }
  }

  recallReport() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportRecallFilterModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportRecallFilterModel.isProvider) {
      this.reportAgingFilter.reportRecallFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportRecallFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportRecallFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportRecallFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportRecallFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportRecallFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  creditCardReceiptReport() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportCreditCardReceiptFilterModel === undefined) {
      this.createMessage('Please select a patient from the Payment List', 'TDOS');
      return;
    }
    
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('PaymentID', this.reportAgingFilter.reportCreditCardReceiptFilterModel.PaymentId, DataTypeEnum.String);
    this.AddParameterToReport('LedgerID', this.reportAgingFilter.reportCreditCardReceiptFilterModel.LedgerId, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('TDOCID', localStorage.getItem('TDOCID'), DataTypeEnum.String);
    this.AddParameterToReport('LOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  ledgerTransactionReport() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportLedgerTransactionFilterModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];
    if (this.reportAgingFilter.reportLedgerTransactionFilterModel.isProvider) {
      this.reportAgingFilter.reportLedgerTransactionFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportLedgerTransactionFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportLedgerTransactionFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportLedgerTransactionFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportLedgerTransactionFilterModel.PracticeId, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportLedgerTransactionFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportLedgerTransactionFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('showProductionReport', this.reportAgingFilter.reportLedgerTransactionFilterModel.showProductionReport, DataTypeEnum.Boolean);
    this.AddParameterToReport('showReceiptReport', this.reportAgingFilter.reportLedgerTransactionFilterModel.showReceiptReport, DataTypeEnum.Boolean);
    this.AddParameterToReport('showActivityReport', this.reportAgingFilter.reportLedgerTransactionFilterModel.showActivityReport, DataTypeEnum.Boolean);
    this.AddParameterToReport('showBankDepositsReport', this.reportAgingFilter.reportLedgerTransactionFilterModel.showBankDepositsReport, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionsReport', this.reportAgingFilter.reportLedgerTransactionFilterModel.showTransactionsReport, DataTypeEnum.Boolean);

    this.AddParameterToReport('isNewPage', this.reportAgingFilter.reportLedgerTransactionFilterModel.isNewPage, DataTypeEnum.Boolean);
    this.AddParameterToReport('isActivityGroupByDoctor', this.reportAgingFilter.reportLedgerTransactionFilterModel.isActivityGroupByDoctor, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionCash', this.reportAgingFilter.reportLedgerTransactionFilterModel.showTransactionCash, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionCreditCard', this.reportAgingFilter.reportLedgerTransactionFilterModel.showTransactionCreditCard, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionDebit', this.reportAgingFilter.reportLedgerTransactionFilterModel.showTransactionDebit, DataTypeEnum.Boolean);
    this.AddParameterToReport('showTransactionOther', this.reportAgingFilter.reportLedgerTransactionFilterModel.showTransactionOther, DataTypeEnum.Boolean);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  financialAuditReport() {
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportFinancialAuditFilterModel === undefined) {

      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportFinancialAuditFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportFinancialAuditFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportFinancialAuditFilterModel.PracticeId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }


  financialSummaryParams() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportFinancialSummaryFilterModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportFinancialSummaryFilterModel.isProvider) {
      this.reportAgingFilter.reportFinancialSummaryFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportFinancialSummaryFilterModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportFinancialSummaryFilterModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportFinancialSummaryFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportFinancialSummaryFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportFinancialSummaryFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('isCurrentMonthParams', this.reportAgingFilter.isCurrentMonth, DataTypeEnum.Boolean);
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  proceduresWithNoClaimsReport(){
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportProceduresWithNoClaimsModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportProceduresWithNoClaimsModel.isProvider) {
      this.reportAgingFilter.reportProceduresWithNoClaimsModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportProceduresWithNoClaimsModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportProceduresWithNoClaimsModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportProceduresWithNoClaimsModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportProceduresWithNoClaimsModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportProceduresWithNoClaimsModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  claimsNoSentReport(){
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportClaimsNotSentModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportClaimsNotSentModel.isProvider) {
      this.reportAgingFilter.reportClaimsNotSentModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportClaimsNotSentModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportClaimsNotSentModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportClaimsNotSentModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportClaimsNotSentModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportClaimsNotSentModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  OutstandingClaimsReport() { 
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportOutstandingClaimsModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportOutstandingClaimsModel.isEClaims) {
            this.AddParameterToReport('isEClaims', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportOutstandingClaimsModel.isADAForm) {
      this.AddParameterToReport('isADAForm', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportOutstandingClaimsModel.Over30) {
      this.AddParameterToReport('Over30', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportOutstandingClaimsModel.Over60) {
      this.AddParameterToReport('Over60', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportOutstandingClaimsModel.Over90) {
      this.AddParameterToReport('Over90', true, DataTypeEnum.Boolean);
    }

    if (this.reportAgingFilter.reportOutstandingClaimsModel.isProvider) {
      this.reportAgingFilter.reportOutstandingClaimsModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilter.reportOutstandingClaimsModel.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportOutstandingClaimsModel.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportOutstandingClaimsModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  referringAnalysisReport() {
    let locationIndex = 0;
    let providerIndex = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportReferringAnalysisModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportReferringAnalysisModel.isProvider) {
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportReferringAnalysisModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + providerIndex, provider, DataTypeEnum.String);
        providerIndex++;
      });
    }

    if (this.reportAgingFilter.reportReferringAnalysisModel.isPractice) {
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportReferringAnalysisModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + locationIndex, location, DataTypeEnum.String);
        locationIndex++;
      });
    }   

    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportReferringAnalysisModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportReferringAnalysisModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('isAll', this.reportAgingFilter.reportReferringAnalysisModel.isAll, DataTypeEnum.Boolean);
    this.AddParameterToReport('IncludePerDoctor', this.reportAgingFilter.reportReferringAnalysisModel.IncludePerDoctor, DataTypeEnum.Boolean);
    this.AddParameterToReport('IncludePerCode', this.reportAgingFilter.reportReferringAnalysisModel.IncludePerCode, DataTypeEnum.Boolean);
    this.AddParameterToReport('IncludeBreakDown', this.reportAgingFilter.reportReferringAnalysisModel.IncludeBreakDown, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  patientsNeedAppointmentReport() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportPatientsNeedAppointmentModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];
      this.reportAgingFilter.reportPatientsNeedAppointmentModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportPatientsNeedAppointmentModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportPatientsNeedAppointmentModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('isNewOnly', this.reportAgingFilter.reportPatientsNeedAppointmentModel.isNewOnly, DataTypeEnum.Boolean);
    this.AddParameterToReport('TDOCID', localStorage.getItem('TDOCID'), DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  financialSnapshotBreakDownParams() {
    this.reportFinancialSnapshotBreakDownFilter.sendFilterToParent();
    if (this.reportFinancialSnapshotFilters === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }

    let i = 0;
    this.activeReport.cfgReportParameters = [];
    //this.AddParameterToReport('ProviderId', this.reportFinancialSnapshotFilters.ProviderId, DataTypeEnum.String);
    this.reportFinancialSnapshotFilters.ProvidersId.forEach(provider => {
      this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
      i++;
    });
    this.AddParameterToReport('SnapshotTypeId', this.reportFinancialSnapshotFilters.TypeId, DataTypeEnum.String);
    this.AddParameterToReport('isCurrentMonth', this.reportFinancialSnapshotFilters.isCurrentMonth, DataTypeEnum.Boolean);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportFinancialSnapshotFilters.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportFinancialSnapshotFilters.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('OrderBy', this.reportFinancialSnapshotFilters.OrderBy, DataTypeEnum.String);
    this.AddParameterToReport('isAsc', this.reportFinancialSnapshotFilters.isAsc, DataTypeEnum.Boolean);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  agingAnalysisParams() {
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilters === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];
    if (this.reportAgingFilters.isProvider) {
      this.reportAgingFilters.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
        i++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    if (this.reportAgingFilters.isPractice) {
      this.AddParameterToReport('PracticeId', this.reportAgingFilters.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilters.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
        i++;
      });
    }
    this.AddParameterToReport('IsTrueBalance', this.reportAgingFilters.IsTrueBalance, DataTypeEnum.Boolean);
    this.AddParameterToReport('IsAllPeriods', this.reportAgingFilters.IsAllPeriods, DataTypeEnum.Boolean);
    this.AddParameterToReport('isCurrent', this.reportAgingFilters.isCurrent, DataTypeEnum.Boolean);
    this.AddParameterToReport('is30Day', this.reportAgingFilters.is30Day, DataTypeEnum.Boolean);
    this.AddParameterToReport('is60Day', this.reportAgingFilters.is60Day, DataTypeEnum.Boolean);
    this.AddParameterToReport('is90Day', this.reportAgingFilters.is90Day, DataTypeEnum.Boolean);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  // DevExpress Report
  financialSnapshotDevExpressParams() {
    // let parameters: IParams;
    this.reportFinancialSnapshotBreakDownFilter.sendFilterToParent();
    if (this.reportFinancialSnapshotFilters === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }


    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('isProvider', this.reportFinancialSnapshotFilters.isProvider, DataTypeEnum.Boolean);
    // this.AddParameterToReport('ProviderId', this.reportFinancialSnapshotFilters.ProviderId, DataTypeEnum.String);
    this.AddParameterToReport('PracticeId', this.reportFinancialSnapshotFilters.PracticeId, DataTypeEnum.Integer);
    this.AddParameterToReport('SnapshotTypeId', this.reportFinancialSnapshotFilters.TypeId, DataTypeEnum.String);
    this.AddParameterToReport('isCurrentMonth', this.reportFinancialSnapshotFilters.isCurrentMonth, DataTypeEnum.Boolean);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportFinancialSnapshotFilters.initialDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportFinancialSnapshotFilters.endDate), 'yyyy/MM/dd HH:mm:ss', 'UTC'), DataTypeEnum.String);
    this.AddParameterToReport('OrderBy', this.reportFinancialSnapshotFilters.OrderBy, DataTypeEnum.String);
    this.AddParameterToReport('isAsc', this.reportFinancialSnapshotFilters.isAsc, DataTypeEnum.Boolean);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  // HTML Report
  financialSnapshotParams() {
    let parameters: IParams;
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportFinancialSnapshotFilterModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    if (this.reportAgingFilter.isInteractiveReport) { // HTML Report
      // this.isSnapShotReport = true;
      this.isSnapshotDevExpress = false;

      parameters = {
        isProvider: this.reportAgingFilter.reportFinancialSnapshotFilterModel.isProvider,
        isPractice: this.reportAgingFilter.reportFinancialSnapshotFilterModel.isPractice,
        ProvidersId: this.reportAgingFilter.reportFinancialSnapshotFilterModel.ProvidersId,
        ProviderId: '',
        PracticeLocations: this.reportAgingFilter.reportFinancialSnapshotFilterModel.PracticeLocations,
        PracticeId: this.reportAgingFilter.reportFinancialSnapshotFilterModel.PracticeId,
        initialDate: this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportFinancialSnapshotFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss'),
        endDate: this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportFinancialSnapshotFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss'),
        isAsc: this.reportAgingFilter.reportFinancialSnapshotFilterModel.isAsc,
        showInactive: this.reportAgingFilter.reportFinancialSnapshotFilterModel.showInactive,
        reportName: 'Snapshot Report',
        dateRange: this.reportAgingFilter.reportFinancialSnapshotFilterModel.dateRange,
        CurrentLocation: this.globals.LOCID
      };
      this.ReportFinancialSnapshot.loadReport(parameters, false);
    } else {

      this.isSnapshotDevExpress = true;
      this.activeReport.cfgReportParameters = [];
      if (this.reportAgingFilter.reportFinancialSnapshotFilterModel.isProvider) {
        this.reportAgingFilter.reportFinancialSnapshotFilterModel.ProvidersId.forEach(provider => {
          this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
          i++;
        });
        this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      }
      if (this.reportAgingFilter.reportFinancialSnapshotFilterModel.isPractice) {
        this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportFinancialSnapshotFilterModel.PracticeId, DataTypeEnum.String);
        this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
        this.reportAgingFilter.reportFinancialSnapshotFilterModel.PracticeLocations.forEach(location => {
          this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
          i++;
        });
      }
      this.AddParameterToReport('showInactive', this.reportAgingFilter.reportFinancialSnapshotFilterModel.showInactive, DataTypeEnum.Boolean);
      this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportFinancialSnapshotFilterModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
      this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportFinancialSnapshotFilterModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
      this.AddParameterToReport('OrderBy', this.reportAgingFilter.reportFinancialSnapshotFilterModel.OrderBy, DataTypeEnum.String);
      this.AddParameterToReport('isAsc', this.reportAgingFilter.reportFinancialSnapshotFilterModel.isAsc, DataTypeEnum.Boolean);
      this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
      this.AddParameterToReport('isDailySnapshot', false, DataTypeEnum.Boolean);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
      this.hasDevReportParam = false;
      this.showParameters();
      this.getReportUrl();
    }
  }

  // HTML Report
  financialDailySnapshotParams() {
    let parameters: IParams;
    let i = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportFinancialSnapshotFilterModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    if (this.reportAgingFilter.isInteractiveReport) { // HTML Report
      this.isSnapshotDevExpress = false;
      parameters = {
        isProvider: this.reportAgingFilter.reportFinancialSnapshotFilterModel.isProvider,
        isPractice: this.reportAgingFilter.reportFinancialSnapshotFilterModel.isPractice,
        ProvidersId: this.reportAgingFilter.reportFinancialSnapshotFilterModel.ProvidersId,
        ProviderId: '',
        PracticeLocations: this.reportAgingFilter.reportFinancialSnapshotFilterModel.PracticeLocations,
        PracticeId: this.reportAgingFilter.reportFinancialSnapshotFilterModel.PracticeId,
        initialDate: this.datePipe.transform(ConversionUtilities.getInitialDate(new Date()), 'yyyy/MM/dd HH:mm:ss'),
        endDate: this.datePipe.transform(ConversionUtilities.getEndDate(new Date()), 'yyyy/MM/dd HH:mm:ss'),
        isAsc: this.reportAgingFilter.reportFinancialSnapshotFilterModel.isAsc,
        showInactive: this.reportAgingFilter.reportFinancialSnapshotFilterModel.showInactive,
        reportName: 'Daily Snapshot Report',
        dateRange: this.reportAgingFilter.reportFinancialSnapshotFilterModel.dateRange,
        CurrentLocation: this.globals.LOCID
      };
      this.ReportFinancialSnapshot.loadReport(parameters, true);
    } else {
      this.isSnapshotDevExpress = true;
      this.activeReport.cfgReportParameters = [];

      if (this.reportAgingFilter.reportFinancialSnapshotFilterModel.isProvider) {
        this.reportAgingFilter.reportFinancialSnapshotFilterModel.ProvidersId.forEach(provider => {
          this.AddParameterToReport('ProviderId' + i, provider, DataTypeEnum.String);
          i++;
        });
        this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      }
      if (this.reportAgingFilter.reportFinancialSnapshotFilterModel.isPractice) {
        this.AddParameterToReport('PracticeId', this.reportAgingFilter.reportFinancialSnapshotFilterModel.PracticeId, DataTypeEnum.String);
        this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
        this.reportAgingFilter.reportFinancialSnapshotFilterModel.PracticeLocations.forEach(location => {
          this.AddParameterToReport('Location' + i, location, DataTypeEnum.String);
          i++;
        });
      }
      this.AddParameterToReport('showInactive', this.reportAgingFilter.reportFinancialSnapshotFilterModel.showInactive, DataTypeEnum.Boolean);
      this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(new Date()), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
      this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(new Date()), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
      this.AddParameterToReport('OrderBy', this.reportAgingFilter.reportFinancialSnapshotFilterModel.OrderBy, DataTypeEnum.String);
      this.AddParameterToReport('isAsc', this.reportAgingFilter.reportFinancialSnapshotFilterModel.isAsc, DataTypeEnum.Boolean);
      this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
      this.AddParameterToReport('isDailySnapshot', true, DataTypeEnum.Boolean);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
      this.hasDevReportParam = false;
      this.showParameters();
      this.getReportUrl();
    }
  }

  frontDeskEnvelopParams() {
    this.ReportFrontDesk.sendFilterToParent();
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.createMessage('Please select Patient', 'TDOS');
      return;
    }
   if (this.reportFrontDeskFilters === undefined) {
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('PersonContactID', this.reportFrontDeskFilters.ContactId, DataTypeEnum.String);
    this.AddParameterToReport('EnvelopSize', this.reportFrontDeskFilters.size, DataTypeEnum.String);
    this.AddParameterToReport('EnvelopFor', this.reportFrontDeskFilters.envelopFor, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();

  }

  frontDeskTreatmentPlanParams() {
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.createMessage('Please select Patient', 'TDOS');
      this.reportUrl = '';
      return;
    }
    this.ReportFrontDesk.sendFilterToParent();
    if (this.reportFrontDeskFilters === undefined || this.reportFrontDeskFilters.ParentTreatmentPlanningID === null || this.reportFrontDeskFilters.ParentTreatmentPlanningID === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      this.reportUrl = '';
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
    this.AddParameterToReport('TreatmentPlanningID', this.reportFrontDeskFilters.TreatmentPlanningID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('TDOCID', localStorage.getItem('TDOCID'), DataTypeEnum.String);
    this.AddParameterToReport('LOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  frontDeskWalkOutSlip() {
    this.activeReport.cfgReportParameters = [];
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.createMessage('Please select Patient', 'TDOS');
      this.reportUrl = '';
      return;
    }
    this.activeReport.cfgReportParameters = [];
    if (!this.isSpecificReport) {
      this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('LOCID', this.globals.LOCID, DataTypeEnum.String);
    } else {
      this.AddParameterToReport('PatientID', this.reportStartUpObject.reportGlobalParameters.PatientID.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('LOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  feeCalculationReport() {
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.createMessage('Please select Patient', 'TDOS');
      this.reportUrl = '';
      return;
    }

    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportFeeCalculationReportModel === undefined || this.reportAgingFilter.reportFeeCalculationReportModel === null) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }

    this.activeReport.cfgReportParameters = [];


    if (!this.isSpecificReport) {
      this.AddParameterToReport('PatientID', this.globals.currentPatientId.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    } else {
      this.AddParameterToReport('PatientID', this.reportStartUpObject.reportGlobalParameters.PatientID.toUpperCase(), DataTypeEnum.String);
      this.AddParameterToReport('CurrentLOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('isOrderedByDate', this.reportAgingFilter.reportFeeCalculationReportModel.isOrderedByDate, DataTypeEnum.Boolean);
    this.AddParameterToReport('isOrderedByToothCode', this.reportAgingFilter.reportFeeCalculationReportModel.isOrderedByToothCode, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  bankDeposits() {
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportBankDepositsModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('CurrentLOCID', this.reportStartUpObject.reportGlobalParameters.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('isCash', this.reportAgingFilter.reportBankDepositsModel.isCash, DataTypeEnum.Boolean);
    this.AddParameterToReport('isCheck', this.reportAgingFilter.reportBankDepositsModel.isCheck, DataTypeEnum.Boolean);
    this.AddParameterToReport('isCashandCheck', this.reportAgingFilter.reportBankDepositsModel.isCashandCheck, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  recallAppointmentReport() {
    let i = 0;
    let locationIndex = 0;
    let providerIndex = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportRecallAppointmentModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }

    this.activeReport.cfgReportParameters = [];
    if (this.reportAgingFilter.reportRecallAppointmentModel.isProvider) {
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportRecallAppointmentModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + providerIndex, provider, DataTypeEnum.String);
        providerIndex++;
      });
    }

    if (this.reportAgingFilter.reportRecallAppointmentModel.isPractice) {
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportRecallAppointmentModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + locationIndex, location, DataTypeEnum.String);
        locationIndex++;
      });
    }   
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportRecallAppointmentModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportRecallAppointmentModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('isFollowUp', this.reportAgingFilter.reportRecallAppointmentModel.isFollowUp, DataTypeEnum.Boolean);
    this.AddParameterToReport('isAllProviders', this.reportAgingFilter.reportRecallAppointmentModel.isAllProviders, DataTypeEnum.Boolean);
    this.AddParameterToReport('isAllLocations', this.reportAgingFilter.reportRecallAppointmentModel.isAllLocations, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  callListReport() {
    let locationIndex = 0;
    let providerIndex = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportCallListModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }

    this.activeReport.cfgReportParameters = [];

    if (this.reportAgingFilter.reportCallListModel.isProvider) {
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportCallListModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + providerIndex, provider, DataTypeEnum.String);
        providerIndex++;
      });
    }

    if (this.reportAgingFilter.reportCallListModel.isPractice) {
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportCallListModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + locationIndex, location, DataTypeEnum.String);
        locationIndex++;
      });
    }
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportCallListModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('isAllProviders', this.reportAgingFilter.reportCallListModel.isAllProviders, DataTypeEnum.Boolean);
    this.AddParameterToReport('isAllLocations', this.reportAgingFilter.reportCallListModel.isAllLocations, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  collectionReport() {
    let providerIndex = 0;
    let locationIndex = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportCollectionFilterModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];
    if (this.reportAgingFilter.reportCollectionFilterModel.isProvider) {
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportCollectionFilterModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + providerIndex, provider, DataTypeEnum.String);
        providerIndex++;
      });
    }
    if (this.reportAgingFilter.reportCollectionFilterModel.isPractice) {
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportCollectionFilterModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + locationIndex, location, DataTypeEnum.String);
        locationIndex++;
      });
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  unappliedCreditsReport() {
    let providerIndex = 0;
    let locationIndex = 0;
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportUnappliedCreditsModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];
    if (this.reportAgingFilter.reportUnappliedCreditsModel.isProvider) {
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportUnappliedCreditsModel.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + providerIndex, provider, DataTypeEnum.String);
        providerIndex++;
      });
    }
    if (this.reportAgingFilter.reportUnappliedCreditsModel.isPractice) {
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      this.reportAgingFilter.reportUnappliedCreditsModel.PracticeLocations.forEach(location => {
        this.AddParameterToReport('Location' + locationIndex, location, DataTypeEnum.String);
        locationIndex++;
      });
    }
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('isAllProviders', this.reportAgingFilter.reportUnappliedCreditsModel.isAllProviders, DataTypeEnum.Boolean);
    this.AddParameterToReport('isAllLocations', this.reportAgingFilter.reportUnappliedCreditsModel.isAllLocations, DataTypeEnum.Boolean);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  deletedAnesthesiaReport() {
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportDeletedAnesthesiaModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportDeletedAnesthesiaModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportDeletedAnesthesiaModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  patientCaseReferralsReport() {
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportPatientCaseReferralsModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    this.activeReport.cfgReportParameters = [];
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
    this.AddParameterToReport('initialDate', this.datePipe.transform(ConversionUtilities.getInitialDate(this.reportAgingFilter.reportPatientCaseReferralsModel.initialDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.AddParameterToReport('endDate', this.datePipe.transform(ConversionUtilities.getEndDate(this.reportAgingFilter.reportPatientCaseReferralsModel.endDate), 'yyyy/MM/dd HH:mm:ss'), DataTypeEnum.String);
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  reportsToBeCompletedReport() {
    this.reportAgingFilter.sendFilterToParent();
    if (this.reportAgingFilter.reportReportsToBeCompletedModel === undefined) {
      this.createMessage('Please select parameters', 'TDOS');
      return;
    }
    let parameters: ReportReportsToBeCompletedParamsModel;
    parameters = {
      isProvider: this.reportAgingFilter.reportReportsToBeCompletedModel.isProvider,
      isPractice: this.reportAgingFilter.reportReportsToBeCompletedModel.isPractice,
      LocationsIdList: this.reportAgingFilter.reportReportsToBeCompletedModel.LocationsIdList,
      ProvidersIdList: this.reportAgingFilter.reportReportsToBeCompletedModel.ProvidersIdList
    };

    this.reportReportsToBeCompleted.onLoadReport(parameters);

  }

  // ============================================================================
  // HELPER METHODS FOR REPORT PARAMETER BUILDING
  // ============================================================================

  /** Shows a validation error message */
  protected showValidationError(message: string): void {
    this.snackBar.open(message, 'TDOX', {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  /** Validates that a patient is selected */
  protected validatePatientSelected(): boolean {
    if (this.globals.currentPatientId === undefined || this.globals.currentPatientId === null) {
      this.showValidationError('Please select Patient');
      return false;
    }
    return true;
  }

  /** Validates that filter model is defined */
  protected validateFilterModel(model: any): boolean {
    if (model === undefined) {
      this.showValidationError('Please select parameters');
      return false;
    }
    return true;
  }

  /** Adds provider parameters to the report */
  protected addProviderParams(model: { isProvider?: boolean; ProvidersId?: string[] }): number {
    let index = 0;
    if (model.isProvider && model.ProvidersId) {
      model.ProvidersId.forEach(provider => {
        this.AddParameterToReport('ProviderId' + index, provider, DataTypeEnum.String);
        index++;
      });
      this.AddParameterToReport('isProvider', true, DataTypeEnum.Boolean);
    }
    return index;
  }

  /** Adds practice/location parameters to the report */
  protected addPracticeParams(model: { isPractice?: boolean; PracticeId?: string; PracticeLocations?: string[] }, startIndex: number = 0): number {
    let index = startIndex;
    if (model.isPractice) {
      this.AddParameterToReport('PracticeId', model.PracticeId, DataTypeEnum.String);
      this.AddParameterToReport('isPractice', true, DataTypeEnum.Boolean);
      if (model.PracticeLocations) {
        model.PracticeLocations.forEach(location => {
          this.AddParameterToReport('Location' + index, location, DataTypeEnum.String);
          index++;
        });
      }
    }
    return index;
  }

  /** Adds date range parameters to the report */
  protected addDateRangeParams(initialDate: Date, endDate: Date, useUTC: boolean = true): void {
    const timezone = useUTC ? 'UTC' : undefined;
    this.AddParameterToReport(
      'initialDate', 
      this.datePipe.transform(ConversionUtilities.getInitialDate(initialDate), 'yyyy/MM/dd HH:mm:ss', timezone), 
      DataTypeEnum.String
    );
    this.AddParameterToReport(
      'endDate', 
      this.datePipe.transform(ConversionUtilities.getEndDate(endDate), 'yyyy/MM/dd HH:mm:ss', timezone), 
      DataTypeEnum.String
    );
  }

  /** Adds common parameters that most reports need */
  protected addCommonParams(): void {
    this.AddParameterToReport('EnterpriseId', this.enterpriseId, DataTypeEnum.String);
    this.AddParameterToReport('CurrentLOCID', this.globals.LOCID, DataTypeEnum.String);
  }

  /** Finalizes report parameter setup and generates URL */
  protected finalizeReportParams(): void {
    this.hasDevReportParam = false;
    this.showParameters();
    this.getReportUrl();
  }

  /** Initializes report parameters (clears existing and sends filter to parent) */
  protected initReportParams(): void {
    this.reportAgingFilter.sendFilterToParent();
    this.activeReport.cfgReportParameters = [];
  }

  AddParameterToReport(ParameterName: string, ParameterValue: any, enumDataTypeID: DataTypeEnum): void {
    const param = new ReportParameterModel();
    param.ParameterName = ParameterName;
    param.enumDataTypeID = enumDataTypeID;
    
    switch (enumDataTypeID) {
      case DataTypeEnum.String:
        param.ParameterValueString = ParameterValue;
        break;
      case DataTypeEnum.Boolean:
        param.ParameterValueBoolean = ParameterValue;
        break;
      case DataTypeEnum.DateTime:
        param.ParameterValueDate = ParameterValue;
        break;
      case DataTypeEnum.Integer:
        param.ParameterValueNumber = ParameterValue;
        break;
    }
    
    this.activeReport.cfgReportParameters.push(param);
  }

  getReportUrl() {

    // let oldGlobal: any = localStorage.getItem('global');
    // oldGlobal = JSON.parse(oldGlobal);

    /* if (oldGlobal != null && oldGlobal.currentPatient != null && storedUser != null && storedUser.authdata.userid != null) {
window.open('https://tdoxletterstestinternal.azurewebsites.net/new-letter/TDOx/' + oldGlobal.currentPatientCase + '/'
+ oldGlobal.currentPatient + ',_' + storedUser.authdata.userid, '_blank', 'toolbar=1,location=0,menubar=1');
} else {
// show message about selecting a patient
}*/
    // this.hostUrl = environment.tdoxReportingUrl;// + this.storedUser.authdata.userid;
    // this.authToken = this.storedUser.authToken;
    // get report path, start report dx-Report-viewer
    this.reportUrl = encodeURIComponent(this.returnReportPath());
    this.isEmptyReport = false;
    // and just for now...
    // this.reportName = this.reportUrl;
    // window.open(this.hostUrl + this.reportUrl , '_blank', 'toolbar=1,location=0,menubar=1');
  }

  runReportToPDF(): void {
    this.reportToPDFUrl = this.hostUrlReporting + 'ReportExport/ExportPDF?reportUrl=' + this.returnReportPath();
    this.goToLink(this.reportToPDFUrl);
  }

  goToLink(url: string): void {
    window.open(url, '_blank');
  }

  returnReportPath(): string {
    // report path return
    let reportPath = '';

    // build params for report
    reportPath = this.activeReport.ServerReportName;
    this.reportViewerParameters = [];
    let params = '';

    // if params entered
    // string params
    this.reportParametersString.forEach(a => {
      if (a.ParameterValueString) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueString;
        viewerParam.name = a.ParameterName;
        const existingIndex = this.reportViewerParameters.findIndex(x => x.name === viewerParam.name);
        if (existingIndex !== -1) {
          this.reportViewerParameters[existingIndex].value = viewerParam.value;
        } else {
          this.reportViewerParameters.push(viewerParam);
        }
      }
    });

    // number params
    this.reportParametersNumber.forEach(a => {
      if (a.ParameterValueNumber) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueNumber.toString();
        viewerParam.name = a.ParameterName;
        const existingIndex = this.reportViewerParameters.findIndex(x => x.name === viewerParam.name);
        if (existingIndex !== -1) {
          this.reportViewerParameters[existingIndex].value = viewerParam.value;
        } else {
          this.reportViewerParameters.push(viewerParam);
        }
      }
    });

    // boolean params
    this.reportParametersBoolean.forEach(a => {
      if (a.ParameterValueBoolean) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueBoolean.toString();
        viewerParam.name = a.ParameterName;
        const existingIndex = this.reportViewerParameters.findIndex(x => x.name === viewerParam.name);
        if (existingIndex !== -1) {
          this.reportViewerParameters[existingIndex].value = viewerParam.value;
        } else {
          this.reportViewerParameters.push(viewerParam);
        }
      }
    });

    // date params
    this.reportParametersDateTime.forEach(a => {
      if (a.ParameterValueDate) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueDate.toString();
        viewerParam.name = a.ParameterName;
        const existingIndex = this.reportViewerParameters.findIndex(x => x.name === viewerParam.name);
        if (existingIndex !== -1) {
          this.reportViewerParameters[existingIndex].value = viewerParam.value;
        } else {
          this.reportViewerParameters.push(viewerParam);
        }
      }
    });

    if (this.reportViewerParameters.length) {
      this.reportViewerParameters.forEach(item => {
        params += '&' + item.name + '=' + item.value;
      });
      params = params.replace('&', '?');
    }

    // finally, append params to url
    reportPath += params;
    // return report path
    return reportPath;
  }

  /*createMessage(message, type) {
    this.validationMessageType = type === 'Error' ? 'critical' : 'warning';
    this.validationMessage = message;
  }*/

  
  createMessage(message, type) {
    this.snackBar.open(message, type, {
        duration: 6000,
        verticalPosition: 'top',
        panelClass: ['snackbar-linebreaks']
    });
}

  isChecked(ReportID: string): boolean {

    if (this.reports.length === 1 && ReportID === this.reports[0].ReportID) {
      return true;
    } else {
      return false;
    }
  }

  onTdoDropdownChange(event: MatSelectChange, row: TdoTableRowModel, enumID: string) {
    row.model[enumID] = event.value.ValidValueItemId;
  }

  getValueByEnumId(locationEnumItems: EnumValidValueItemModel[], enumEndoFractureLocationID: string
  ) {
    return locationEnumItems.find(p => p.ValidValueItemId === enumEndoFractureLocationID);
  }

  getReportCategory(enumReportCategoryID: string) {
    if (this.reportCategoryEnumItems) {
      const pri = this.reportCategoryEnumItems.find(p => p.ValidValueItemId === enumReportCategoryID);
      return pri;
    }
    return null;
  }

  onUserReportCategoryChange(event: any): void {
    this.selectedEnumReportCategoryID = event.value.ValidValueItemId;
    this.selectedEnumReportCategory = event.value;
    this.blReportByCategorySelected = true;
    this.updateReportsByCategory(); // Refresh cached reports
    this.hideAllFilters();
  }

  /** Returns cached filtered reports by category */
  get reportsByCategory(): ReportListModel[] {
    return this._cachedReportsByCategory;
  }

  /** Updates the cached reports by category - call when category changes */
  private updateReportsByCategory(): void {
    this._cachedReportsByCategory = this.reports
      .filter(x => x.enumReportCategoryID === this.selectedEnumReportCategoryID 
                && x.enumReportClassID === ReportClass.ReportViewer)
      .sort((a, b) => a.ReportOrderInCategory - b.ReportOrderInCategory);
  }

  BeforeRender(pEvent: any) {
    pEvent.args.reportPreview.zoom = 1;
  }

  onDocumentReady(pEvent: any) {
    const self = this;
    const reportPreview = (self.viewer.bindingSender as any).GetReportPreview();
    (reportPreview as any).zoom = 0.25;
  }

  childOnChecked(isChecked: boolean) {
    this.isSnapshotDevExpress = !isChecked;
    this.reportUrl = '';
  }

  hideAllFilters() {
    this.showAgingFilters = false;
    this.showFinancialSummaryFilters = false;
    this.showFinancialSnapshotFilters = false;
    this.showReportsToBeCompletedFilters = false;
    this.showFrontDeskFilters = false;
    this.hasDevReportParam = false;
  }

  transformReportName(reportName: string): string {
    return reportName.toLowerCase().replaceAll(/\s+/g, '-');
  }

  /** TrackBy function for report list to improve ngFor performance */
  trackByReportId(index: number, report: ReportListModel): string {
    return report.ReportID;
  }
}
